import * as React from 'react';
import { SVGIcon, SVGIconProps } from '../SvgIcon';

export let ComposeIcon = (props: SVGIconProps) => (
    <SVGIcon viewBox="0 0 16 16" width="16" height="16" {...props}>
        <path d="M1.6,3.2V14.4H12.8V9.6L14.4,8v8H0V1.6H8L6.4,3.2Zm8.24-.24,3.2,3.2L6.4,12.8H3.2V9.6L9.84,2.96Zm1.12-1.12L12.8,0,16,3.2,14.16,5.04l-3.2-3.2Z" />
    </SVGIcon>
);
